import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import PaymentDomain from "entities/domain/payments/payment-domain";
import { RootState } from "redux/store";

export interface UpdatePaymentPayload {
  id: any;
  status: string | undefined;
  payment_method: string | undefined;
}

interface PaymentState {
  selectedPaymentId: string | undefined;
}

const initialState: PaymentState = {
  selectedPaymentId: undefined,
};

const paymentsSlice = createSlice({
  name: "payments",
  initialState,
  reducers: {
    setSelectedPayment(state, action: PayloadAction<string | undefined>) {
      state.selectedPaymentId = action.payload;
    },
    resetStore(state) {
      state.selectedPaymentId = undefined;
    },
  },
});

export const paymentsSelector = (state: RootState) => state.payments;

export const selectPayment = (
  paymentId: string | undefined,
  payments: PaymentDomain[]
): PaymentDomain | undefined => {
  if (!paymentId || !payments) return undefined;
  return payments.find((pay) => pay.id === paymentId);
};

export const { setSelectedPayment, resetStore } = paymentsSlice.actions;
export const paymentsSliceActions = paymentsSlice.actions;
export default paymentsSlice.reducer;
